enum PaymentType {
  PAYPAL = 'paypal',
  CREDIT_CARD = 'credit_card',
  APPLE_PAY = 'apple_pay',
  VENMO = 'venmo',
}

export default PaymentType;
